import { createTheme, responsiveFontSizes } from "@mui/material/styles";

let theme = createTheme({
  palette: {
    mainColor: {
      main: "#005B3B",
      light: "#1a7a52",
      dark: "#003d28",
      contrastText: "#ffffff",
    },
    secondColor: {
      main: "#D4AE60",
      light: "#e0c47e",
      dark: "#b8923a",
      contrastText: "#081A28",
    },
    blueDark: {
      main: "#081A28",
      light: "#0f2d45",
      dark: "#030e17",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f8f7f4",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: [
      "'Montserrat'",
      "'Open Sans'",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      "sans-serif",
    ].join(","),
    h1: { fontFamily: "'Montserrat', sans-serif", fontWeight: 800, letterSpacing: "-0.5px" },
    h2: { fontFamily: "'Montserrat', sans-serif", fontWeight: 800, letterSpacing: "-0.5px" },
    h3: { fontFamily: "'Montserrat', sans-serif", fontWeight: 700 },
    h4: { fontFamily: "'Montserrat', sans-serif", fontWeight: 700 },
    h5: { fontFamily: "'Montserrat', sans-serif", fontWeight: 600 },
    h6: { fontFamily: "'Montserrat', sans-serif", fontWeight: 600 },
    subtitle1: { fontFamily: "'Open Sans', sans-serif", fontWeight: 400 },
    body1: { fontFamily: "'Open Sans', sans-serif" },
    body2: { fontFamily: "'Open Sans', sans-serif" },
    button: { fontFamily: "'Montserrat', sans-serif", fontWeight: 700, letterSpacing: "1.5px" },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "uppercase",
          borderRadius: 2,
          padding: "10px 28px",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 4,
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
